import script from "./social.vue?vue&type=script&setup=true&lang=js"
export * from "./social.vue?vue&type=script&setup=true&lang=js"

import "./social.vue?vue&type=style&index=0&id=05d0dd8e&scoped=true&lang=css"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d0dd8e"]])

export default __exports__